import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="3ikr002qv3a7b">
      <MetaPixel data-id="element-1" data-mp="3mkrcviybbdc9" />
      <main data-id="element-2" data-mp="3mk84otygs3bf">
        <Hero data-id="element-3" data-mp="3mjq27fl7ksv2" />
        <Testimonials data-id="element-4" data-mp="3mjgclt42snpw" />
        <ProblemSection data-id="element-5" data-mp="3rcj7q5oi4587" />
        <SystemSection data-id="element-6" data-mp="3rdaquh0wwahl" />
        <ModulesSection data-id="element-7" data-mp="3rcsxbs5mwadd" />
        <BonusSection data-id="element-8" data-mp="3relvej26lm9r" />
        <UrgencySection data-id="element-9" data-mp="5opww5kum4f" />
        <PricingSection data-id="element-10" data-mp="4wwnrzgd0hb" />
        <MoreResults data-id="element-11" data-mp="56n1goet9nj" />
        <GuaranteeSection data-id="element-12" data-mp="7stte3h7l4p" />
        <FAQ data-id="element-13" data-mp="2zllcouynw8jk" />
        <ClosingSection data-id="element-14" data-mp="2zm4ywnvchj3e" />
        <SummaryTable data-id="element-15" data-mp="2zmo89g6xiz5t" />
        <FinalCta data-id="element-16" data-mp="2zng32ospcsv1" />
      </main>
      <Footer data-id="element-17" data-mp="33m5bs42spm8c" />
      <PurchaseNotification data-id="element-18" data-mp="33nq4rp9gox43" />
    </div>;
}